/* eslint-disable */
import React, { useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.span`
  font-size: 1.6rem;
  color: #4a4a4a;
`;

const ActionLink = styled.span`
  font-size: 1.6rem;
  color: #4a4ba9;
  cursor: pointer;
  user-select: none;
  margin-top: 8px;

  &:hover {
    text-decoration: underline;
  }
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const UploadedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const UploadedPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PreviewCircle = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #4a4ba9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.2rem;
  line-height: 1;
`;

const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
`;

const SecondaryAction = styled.span`
  font-size: 1.3rem;
  color: #4a4ba9;
  cursor: pointer;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
`;

interface ExistingFile {
  id?: string;
}

interface Props {
  label?: string;
  actionText?: string;
  accept?: string;
  existingFile?: ExistingFile | null;
  onFileSelect?: (file: File | null) => void;
  onRemoveExistingFile?: (file: ExistingFile | null) => void;
}

const UploadLink: React.FC<Props> = ({
  label,
  actionText,
  accept,
  existingFile,
  onFileSelect,
  onRemoveExistingFile,
}) => {
  const fileRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const hasSelectedFile = !!selectedFile;
  const hasExistingFile = !!existingFile;
  const hasFile = hasSelectedFile || hasExistingFile;

  const openFileDialog = () => {
    fileRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (!file) return;

    // If replacing existing file
    if (existingFile) {
      onRemoveExistingFile?.(existingFile);
    }

    setSelectedFile(file);
    onFileSelect?.(file);
  };

  const handleRemove = () => {
    // Remove newly selected file
    if (hasSelectedFile) {
      setSelectedFile(null);

      if (fileRef.current) {
        fileRef.current.value = '';
      }

      onFileSelect?.(null);
      return;
    }

    // Remove existing file
    if (hasExistingFile) {
      if (fileRef.current) {
        fileRef.current.value = '';
      }

      onRemoveExistingFile?.(existingFile);
    }
  };

  const handleReplace = () => {
    fileRef.current?.click();
  };

  return (
    <Wrapper>
      {label ? <Label>{label}</Label> : null}

      {!hasFile ? (
        <ActionLink onClick={openFileDialog}>{actionText}</ActionLink>
      ) : (
        <UploadedWrapper>
          <UploadedPreview>
            {/* 🔹 ICON ONLY */}
            <PreviewCircle>☰</PreviewCircle>
          </UploadedPreview>

          <ActionsRow>
            <SecondaryAction onClick={handleReplace}>Replace</SecondaryAction>
            <SecondaryAction onClick={handleRemove}>Remove</SecondaryAction>
          </ActionsRow>
        </UploadedWrapper>
      )}

      <HiddenFileInput ref={fileRef} type="file" accept={accept} onChange={handleChange} />
    </Wrapper>
  );
};

UploadLink.defaultProps = {
  label: '',
  actionText: 'Attach',
  accept: '',
  existingFile: null,
  onFileSelect: (file: File | null) => file,
  onRemoveExistingFile: (file: ExistingFile | null) => file,
};

export default UploadLink;
